import { EventHandler } from '../../../CommonComponents'
import './Navigation.scss'

const NavigationContainer = (props:any) => {

  return <>
    <div className='navigation-wrapper' id='navigation-wrapper' ref={props?.wrapperRef}>
      <nav className='header-navigation'>
        <ul className={`navmenu-list navmenu-list-activeasset`}>
          {
            props?.menuListActiveAsset.map((item:any, _index:any) => {
              return (            
                <li key={item.id}
                  title={item.Title}
                  className={item.activeToggle === true ? 'active' : ''}>
                  <EventHandler onEvent={() => { props?.handleClick(item) }} data-attribute={`Navigation_${(item?.text || _index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                    <a href='/'><span className={`menu-icon ${item.icon}`}></span><p>{item.text}</p></a>
                  </EventHandler>
                </li>)
            })
          }
        </ul>
      </nav>
    </div>
  </>
}

export default NavigationContainer
